module.exports = __webpack_public_path__ + "img/person-badgebo.07abf9f1.png";